import { render } from "./sysTenantSearch.vue?vue&type=template&id=10c3991a"
import script from "./sysTenantSearch.vue?vue&type=script&lang=js"
export * from "./sysTenantSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__